import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import PageLoading from '@/components/Common/PageLoading';
import Transition from '@/components/Common/Transition';
import ErrorPage from '@/features/App/ErrorPage';

const SuspenseLayout = () => (
  <ErrorBoundary fallback={<ErrorPage />}>
    <Suspense
      fallback={
        <PageLoading
          style={{ position: 'relative' }}
          wrapperStyle={{ backgroundColor: 'transparent' }}
        />
      }
    >
      <Transition status style={{ overflow: 'hidden', height: '100vh' }}>
        <Outlet />
      </Transition>
    </Suspense>
  </ErrorBoundary>
);

export default SuspenseLayout;
